import React from 'react';
import InputWithLabel from '../LoanApplication/components/commons/InputWithLabel';
import CalculatorForm from './components/calculators-layout/CalculatorForm';
import MinimalCalculatorLayout from './components/calculators-layout/MinimalCalculatorLayout';
import RepaymentYear from '../../components/RepaymentYear';
import Select from '../LoanApplication/components/commons/Select'

const liveInRate = I18n.t('calculators.interest_matrix.live.regular.payg_variable')[0];
const interestRate = I18n.t('calculators.interest_matrix');

export const keyProducts = {
  lowRateHome: {
    objective: "live",
    label: "Low rate home loan - 60% LVR (Variable)",
    lvr: "regular",
    value: "lowRateHome",
    rate: interestRate.live.regular.payg_variable[0],
    settlementFee: 150,
    onGoingFeePerYear: 0,
    dischargeFee: 700,
  },
  offsetHome: {
    value: "offsetHome",
    label: "Offset home loan - 60% LVR (Variable)",
    objective: "live",
    lvr: "regular",
    rate: interestRate.live.regular.variable[0],
    settlementFee: 150,
    onGoingFeePerYear: 120,
    dischargeFee: 700,
  },
  lowDocHome: {
    value: "lowDocHome",
    label: "Low doc home loan - 65% LVR (Variable)",
    objective: "live",
    lvr: "special",
    rate: interestRate.live.poor.variable[0],
    settlementFee: 1290,
    onGoingFeePerYear: 395,
    dischargeFee: 895,
  },
  lowRateInvestor: {
    value: "lowRateInvestor",
    label: "Low rate investor loan - 80% LVR (Variable)",
    objective: "invest",
    lvr: "special",
    rate: interestRate.invest.regular.payg_variable[0],
    settlementFee: 200,
    onGoingFeePerYear: 0,
    dischargeFee: 700,
  },
  offsetInvestor: {
    value: "offsetInvestor",
    label: "Offset investor loan - 80% LVR (Variable)",
    objective: "invest",
    lvr: "special",
    rate: interestRate.invest.regular.variable[0],
    settlementFee: 200,
    onGoingFeePerYear: 395,
    dischargeFee: 700,
  },
  lowDocInvestor: {
    value: "lowDocInvestor",
    label: "Low doc investor loan - 65% LVR (Variable)",
    objective: "invest",
    lvr: "poor",
    rate: interestRate.invest.poor.variable[0],
    settlementFee: 1290,
    onGoingFeePerYear: 395,
    dischargeFee: 895,
  },
  smsfResidential: {
    value: "smsfResidential",
    label: "SMSF residential loan - 70% LVR (Variable)",
    objective: "invest",
    lvr: "regular",
    rate: interestRate.invest.smsf.variable[0],
    settlementFee: 495,
    onGoingFeePerYear: 395,
    dischargeFee: 2200,
  },
};

class KeyFactsCalculator extends React.Component {
  state = {
    loanAmount: 500000,
    objective: "live",
    lvr: "special",
    loanTerm: 30,
    interestType: "variable",
    matchingLoans: liveInRate,
    matchingLoansString: liveInRate.toString(),
    fixedRatePeriod: "fixed1year",
    selectedProduct: "lowRateHome",
    errors: {
      loanAmount: "",
      loanTerm: "",
    },
  };

  fixedRatePeriods = [
    { value: "fixed1year", label: "1 year" },
    { value: "fixed2year", label: "2 years" },
    { value: "fixed3year", label: "3 years" },
    { value: "fixed5year", label: "5 years" },
  ];


  keyFactProducts = Object.values(keyProducts);

  handleKeyFactProducts = (selectedProduct) => {
    const product = keyProducts[selectedProduct];

    this.setState({
      selectedProduct: product.value,
      lvr: product.lvr,
      objective: product.objective,
      matchingLoans: product.rate,
    });
  };

  onCalculationSubmit = () => {
    this.setState({ errors: { loanAmount: "", loanTerm: "" } });
    const {
      loanAmount,
      objective,
      lvr,
      loanTerm,
      interestType,
      fixedRatePeriod,
      matchingLoans,
      selectedProduct,
    } = this.state;
    const url = `/calculators/key-facts-document?loanAmount=${loanAmount}&objective=${objective}&lvr=${lvr}&termOfLoan=${loanTerm}&interestType=${interestType}&matchingLoans=${matchingLoans}&fixedRatePeriod=${fixedRatePeriod}&selectedProduct=${selectedProduct}`;
    const errors = {
      loanAmount: "",
      loanTerm: "",
    };
    if (this.state.loanAmount <= 0) {
      errors.loanAmount = "Amount must be greater than 0";
    }
    if (this.state.loanTerm === 0) {
      errors.loanTerm = "Loan term must be greater than 0";
    }

    this.setState({ errors });

    if (this.state.loanAmount > 0 && this.state.loanTerm) {
      window.location.href = url;
    }
  };

  calculatorForm() {
    const { loanAmount, loanTerm, errors, selectedProduct } = this.state;

    return (
      <div className="key-facts-calculator-form mb-3">
        <div className="numeric-input">
          <InputWithLabel
            label="Loan amount"
            type="currency"
            defaultValue={loanAmount}
            errorMessage={errors["loanAmount"]}
            onChange={(value) => this.setState({ loanAmount: value })}
          />
        </div>
        <RepaymentYear
          label="Term of loan (years)"
          defaultValue={loanTerm}
          onChange={(value) => this.setState({ loanTerm: value })}
        />
        {errors.loanTerm ? (
          <p className="term-error">{errors.loanTerm}</p>
        ) : null}
        <Select
          defaultValue={selectedProduct}
          options={this.keyFactProducts}
          onChange={this.handleKeyFactProducts}
          placeholder={"Select"}
          className="form-control-react-select"
        />
      </div>
    );
  }

  render() {
    return (
      <div className="key-facts-calculator">
        <MinimalCalculatorLayout
          formColumn={
            <CalculatorForm handleSubmit={this.onCalculationSubmit}>
              {this.calculatorForm()}
            </CalculatorForm>
          }
        />
      </div>
    );
  }
}

export default KeyFactsCalculator;
